import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ISODateString } from "components/formatting/ISODateTime";

interface DateRangeLabelProps {
  start: string;
  end?: string;
  useUTC?: boolean;
}

export default function DateRangeLabel(props: DateRangeLabelProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const startDate = ISODateString(i18n, props.start, undefined, props.useUTC);
  const endDate = props.end && ISODateString(i18n, props.end, undefined, props.useUTC) || "Now";
  const usageTermLabel = i18n.t("date-range-label.format", {end: endDate, start: startDate});

  return (
    <Typography>{usageTermLabel}</Typography>
  );
}